const CULTURE = 'fr-FR'

/* Rates are formatted en-US, deliberately, where money is fr-FR. Two reasons,
   and neither is taste:

     1. These numbers sit inside English sentences ("0.5% per quarter"), not in
        a figures column. A comma decimal reads as a thousands separator there.

     2. It makes the computed fee paragraph render BYTE-IDENTICALLY to the
        hardcoded string it replaces on the 4,871 invoices frozen at 0.5% per
        quarter, so the visible change is exactly the 703 invoices that were
        always wrong -- and nothing else. */
const CULTURE_RATE = 'en-US'

export function padNumber(number, nb, symbol = '0') {
  return String(number).padStart(nb, symbol)
}

export function formatNumber(number, options = {
  integer: 1,
  decimal: 0
}) {
  if (typeof number === 'undefined' || number === null) {
   return 0
  }

  return new Intl.NumberFormat(CULTURE, {
    style: 'decimal',
    minimumIntegerDigits: options.integer,
    minimumFractionDigits: options.decimal,
    maximumFractionDigits: options.decimal
  }).format(number)
}

export function formatDecimal(number, options = {
  integer: 1,
  decimal: 2
}) {
  if (typeof number === 'undefined' || number === null) {
    return 0
  }

  return new Intl.NumberFormat(CULTURE, {
    style: 'decimal',
    minimumIntegerDigits: options.integer,
    minimumFractionDigits: options.decimal,
    maximumFractionDigits: options.decimal
  }).format(number)
}

/* A CONFIGURED RATE, not a money amount.
 *
 * formatDecimal() is fixed at 2 decimals, which silently TRUNCATES a real rate:
 * the 0.123% per quarter frozen on one live invoice renders as "0,12%". The
 * frozen history carries 0, 0.123, 0.25, 0.3 and 0.5, so 3 decimals is the
 * requirement and 2 is a data loss on a contractual figure.
 *
 * No minimum, because trailing zeros on a whole rate ("30,00%") assert a
 * precision the field does not have.
 *
 * 3 is sufficient for the annualisation too: x4 is x2 twice, and doubling a
 * terminating decimal never adds a decimal place.
 *
 * Nor does x4 introduce rounding of its own -- multiplying by a power of two
 * only shifts the exponent -- so the annual figure carries exactly the error
 * already present in the stored rate and no more. 0.123 * 4 formats as 0.492,
 * which is what the decimal arithmetic gives. No rounding hack needed. */
export function formatRate(number) {
  if (typeof number === 'undefined' || number === null) {
    return 0
  }

  return new Intl.NumberFormat(CULTURE_RATE, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
  }).format(number)
}
